// extracted by mini-css-extract-plugin
export var category = "footer-module--category--3wZ0V";
export var categoryPart = "footer-module--categoryPart--g-x7R";
export var categoryTitle = "footer-module--categoryTitle--ECNhN";
export var categoryWrapper = "footer-module--categoryWrapper--slE-f";
export var footer = "footer-module--footer--lU7l1";
export var getInTouchCategories = "footer-module--getInTouchCategories--whNSd";
export var getInTouchCategory = "footer-module--getInTouchCategory--qBS2i";
export var getInTouchPart = "footer-module--getInTouchPart--1LXMN";
export var getInTouchTitle = "footer-module--getInTouchTitle--AdfyK";
export var getInTouchWrapper = "footer-module--getInTouchWrapper--nZ2Ro";
export var legalPart = "footer-module--legalPart--9W0cI";
export var legalWrapper = "footer-module--legalWrapper--eNnt6";
export var ltgLogo = "footer-module--ltgLogo---RQhe";
export var sbShowMain = "footer-module--sb-show-main--rVCcG";
export var social = "footer-module--social--AXYhi";
export var socialList = "footer-module--socialList--Oi8Vr";
export var title = "footer-module--title--u4wuF";